import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { Login as RedesignLogin } from '../../../pages';
import * as Api from '../../Api';
import * as Data from '../../Data';
import * as cookieConsentActions from '../../redux/cookie-consent/actions';
import { cookieSelectors } from '../../selectors';
import { flagService } from '../../services';
import * as Store from '../../Store';
import { default as LegacyPhoneNumber } from './index.weborder';

const pageComponent = flagService.componentToggle(
  'uiRedesign',
  RedesignLogin,
  LegacyPhoneNumber,
);

export type StateProps = {
  AppConfig: Data.Async<Api.AppConfig>;
  AppDesignScheme: Api.AppDesignScheme;
  enableRememberMe: boolean;
  isDark: boolean;
  languageCode: Store.Language['code'];
  LastRestaurantUrl: string;
  PhoneNumberConfig: Api.PhoneNumberConfig;
  rememberMe: boolean;
  translate: any;
};

export type DispatchProps = ReturnType<typeof mapDispatchToProps>;

const mapStateToProps = (state: Store.State): StateProps => {
  const {
    flipdish: { LastRestaurantUrl, AppConfig, PhoneNumberConfig, isDark },
    appDesignScheme,
    cookieConsent,
    locale: { languages },
  } = state;

  return {
    AppConfig,
    AppDesignScheme: appDesignScheme,
    enableRememberMe: cookieSelectors.enableRememberMe(state),
    isDark: isDark,
    languageCode: languages.find((lang) => lang.active)?.code || '',
    LastRestaurantUrl,
    PhoneNumberConfig,
    rememberMe: cookieConsent.rememberMe,
    translate: getTranslate(state.locale),
  };
};

const mapDispatchToProps = (
  dispatch: ThunkDispatch<Store.State, {}, Action>,
) => ({
  setRememberMe: (value: boolean) =>
    dispatch(cookieConsentActions.setRememberMe(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(pageComponent);
